import { ModifierTypeMap } from '../../Prototype/Level/Card/ModifierTypeMap';
import { ICardModifierData } from '../../Prototype/Level/Card/ICardModifierData';
import { ICardsState } from './ICardState';
import { IGameState } from '../Game/IGameState';
import CardStateHelper from './CardStateHelper';

export default class CardStateModifierHelper {
    public static playModifier(state: IGameState, modifier: ICardModifierData, cardID: string): IGameState {
        const modBehavior = CardStateModifierHelper.getModifierBehavior(state.levelState.cardsState, modifier, cardID);

        state = modBehavior.play(state);

        const cardsState = modBehavior.updateModifier(state.levelState.cardsState, cardID, {
            properties: {
                ...modifier.properties,
                plays: modifier.properties.plays + 1,
            },
        });

        return CardStateHelper.updateGameState(state, cardsState);
    }

    public static getModifierBehavior(state: ICardsState, modifier: ICardModifierData, cardID: string) {
        return new ModifierTypeMap[modifier.type].behavior(modifier, cardID);
    }

    /**
     * Trigger an 'update' for all modifiers in play.
     * @param state
     * @param sourceCardID
     * @param isCardFold Special case update for modifiers that are updating via a card-fold action (fog).
     */
    public static updateModifiers(state: IGameState, sourceCardID: string, isCardFold: boolean = false): IGameState {
        // Call update() for each modifier.
        const allCards = CardStateHelper.getAllCardIds(state);

        allCards.forEach(cardID => {
            state.levelState.cardsState.cards[cardID].modifiers.forEach((modifier: ICardModifierData) => {
                const modBehavior = CardStateModifierHelper.getModifierBehavior(
                    state.levelState.cardsState,
                    modifier,
                    cardID
                );

                if (isCardFold) {
                    state = modBehavior.onCardFolded(state, sourceCardID);
                } else {
                    state = modBehavior.onCardMatched(state, sourceCardID);
                }
            });
        });

        // Call lateUpdate() for each modifier.
        allCards.forEach(cardID => {
            state.levelState.cardsState.cards[cardID].modifiers.forEach((modifier: ICardModifierData) => {
                const modBehavior = CardStateModifierHelper.getModifierBehavior(
                    state.levelState.cardsState,
                    modifier,
                    cardID
                );
                state = modBehavior.onCardMatchedLate(state);
            });
        });
        return state;
    }

    public static onCardPlayed(state: IGameState, cardID: string): IGameState {
        state.levelState.cardsState.cards[cardID].modifiers.forEach(modifier => {
            state = CardStateModifierHelper.getModifierBehavior(
                state.levelState.cardsState,
                modifier,
                cardID
            ).onOwnCardPlayed(state);
        });

        return state;
    }

    /**
     * Updates state with the provided function for each modifier
     * @param state
     * @param func - state update function
     */
    public static forEachModifier(
        state: IGameState,
        cardID: string,
        func: (state: IGameState, modifier: ICardModifierData, index: number, array: ICardModifierData[]) => IGameState
    ): IGameState {
        CardStateHelper.getCardStateData(state, cardID).modifiers.forEach((modifier, index, array) => {
            state = func(state, modifier, index, array);
        });

        return state;
    }
}
